import React from "react";
import PropTypes from "prop-types";
import { reduxForm } from "redux-form";
import RadioInput from "./RadioInput";
import DayInput from "./DayInput";
import MonthInput from "./MonthInput";
import YearInput from "./YearInput";
import WizardFooter from "./WizardFooter";
import TextInput from "./TextInput";
export const fields = [
  "has_been_unemployed",
  "has_received_unemployment_compensation",
  "unemploymentStartMonth",
  "unemploymentStartDay",
  "unemploymentStartYear",
  "unemployment_state",
];

const validate = (values, props) => {
  const errors = {};
  const { required } = props.allText.shared;
  if (!values.has_been_unemployed) {
    errors.has_been_unemployed = props.allText.shared.required;
  }
  if (!values.has_received_unemployment_compensation) {
    errors.has_received_unemployment_compensation = required;
  }
  if (
    values.has_been_unemployed === "true" &&
    values.has_received_unemployment_compensation === "true"
  ) {
    if (!values.unemploymentStartMonth) {
      errors.unemploymentStartMonth = props.allText.shared.required;
    }
    if (!values.unemploymentStartDay) {
      errors.unemploymentStartDay = props.allText.shared.required;
    }
    if (!values.unemploymentStartYear) {
      errors.unemploymentStartYear = props.allText.shared.required;
    }
    if (!values.unemployment_state) {
      errors.unemployment_state = props.allText.shared.required;
    }
  }
  return errors;
};

export const WizardFormSection10 = props => {
  const {
    allText,
    fields: {
      has_been_unemployed,
      has_received_unemployment_compensation,
      unemploymentStartMonth,
      unemploymentStartDay,
      unemploymentStartYear,
      unemployment_state,
    },
    handleSubmit,
    previousPage,
  } = props;
  const text = { ...allText.shared, ...allText.section10 };
  const progress = 9;
  return (
    <form onSubmit={handleSubmit} className="form-horizontal">
      <div className="wizard-page-content">
        <div className="page-title-container">
          <span className="page-title underline">{text.title}</span>
          <span className="wizard-text question-text">{text.subtitle}</span>
        </div>
        <div className="single-answer-margin-bigger">
          <div className="primary-question">{text.primaryQuestion}</div>

          <div className="separator" />

          <div className="row">
            <div className="col-12 col-sm-6">
              <div className="wizard-text">{text.question01}</div>
              <RadioInput
                text={text}
                field={has_been_unemployed}
                options={["true", "false"]}
              />
            </div>

            <div className="col-12 col-sm-6">
              <div className="wizard-text">{text.question02}</div>
              <RadioInput
                text={text}
                field={has_received_unemployment_compensation}
                options={["true", "false"]}
              />
            </div>
          </div>

          <div className="conditional-question">
            {has_been_unemployed.value === "true" &&
              has_received_unemployment_compensation.value === "true" && (
                <div className="row">
                  <div className="col-12 col-sm-6">
                    <div className="wizard-text">{text.unemploymentStart}</div>

                    <div className="row">
                      <div className="col-4">
                        <MonthInput
                          text={text}
                          field={unemploymentStartMonth}
                        />
                      </div>
                      <div className="col-3 cell-tight">
                        <YearInput
                          text={text}
                          field={unemploymentStartYear}
                          monthSelected={unemploymentStartMonth}
                          shouldCheckMonth={true}
                        />
                      </div>
                      <div className="col-5">
                        <DayInput
                          text={text}
                          field={unemploymentStartDay}
                          monthSelected={unemploymentStartMonth}
                          yearSelected={unemploymentStartYear}
                        />
                      </div>
                    </div>
                    <span className="wizard-text">{text.date_selection}</span>
                  </div>

                  <div className="col-12 col-sm-6">
                    <div className="wizard-text">{text.unemployment_state}</div>
                    <TextInput text={text} field={unemployment_state} />
                  </div>
                </div>
              )}
          </div>
        </div>
      </div>
      <WizardFooter
        text={text}
        previousPage={previousPage}
        progress={progress}
        nextLabel={text.finish}
      />
    </form>
  );
};

WizardFormSection10.propTypes = {
  allText: PropTypes.object.isRequired,
  fields: PropTypes.object.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  previousPage: PropTypes.func.isRequired,
};

export default reduxForm({
  form: "wizard",
  fields,
  destroyOnUnmount: false,
  validate,
})(WizardFormSection10);



// WEBPACK FOOTER //
// ./src/components/WizardFormSection10.js